import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCupHot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCupHot"><Path d="M7.75 2V6H6.25V2H7.75Z" fill="currentColor"/><Path d="M11.75 2V6H10.25V2H11.75Z" fill="currentColor"/><Path d="M15.75 2V6H14.25V2H15.75Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18 7H4V22H18V16H18.5C20.433 16 22 14.433 22 12.5C22 10.567 20.433 9 18.5 9H18V7ZM18 10.5V14.5H18.5C19.6046 14.5 20.5 13.6046 20.5 12.5C20.5 11.3954 19.6046 10.5 18.5 10.5H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCupHot;
